import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { EditorColorPickerProps } from 'modules/Editor/components/ColorPicker/ColorPicker.types';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { onColorPickerContainerBlur } from '../TextBasedWidgets.helpers';

export const TextColor = memo(
  ({ onChange, color, onClose, colorCheckerProps, showNoColorChecker, showBrandSection }: EditorColorPickerProps) => {
    const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'textToolbar' });
    const label = t('fontColor');

    return (
      <ColorPicker
        iconStyle='text'
        color={color ?? ''}
        label={label}
        onChange={onChange}
        onClose={onClose}
        onContainerBlur={onColorPickerContainerBlur}
        showNoColorOption={false}
        colorCheckerProps={colorCheckerProps}
        showNoColorChecker={showNoColorChecker}
        showBrandSection={showBrandSection}
      />
    );
  },
);

TextColor.displayName = 'TextColor';
